/**
 * @fileoverview 二维码生成工具
 * @description 使用qrcode库生成二维码图片
 * @author wangzhongsheng
 * @version 1.0.0
 */

import QRCode from 'qrcode'

/**
 * 生成二维码
 * @param {string} text - 要生成二维码的文本内容
 * @param {Object} options - 二维码配置选项
 * @returns {Promise<string>} 二维码的base64数据URL
 */
export const generateQRCode = async (text, options = {}) => {
  try {
    const defaultOptions = {
      width: 200,
      height: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    }
    
    const qrOptions = { ...defaultOptions, ...options }
    return await QRCode.toDataURL(text, qrOptions)
  } catch (error) {
    console.error('生成二维码失败:', error)
    throw error
  }
}

/**
 * 生成二维码图片（别名函数，为了兼容性）
 * @param {string} text - 要生成二维码的文本内容
 * @param {Object} options - 二维码配置选项
 * @returns {Promise<string>} 二维码的base64数据URL
 */
export const generateQRCodeImage = generateQRCode 